import cloneDeep from 'lodash/cloneDeep'
import state from '@/store/modules/departments/state.js'
import actions from '@/store/modules/departments/actions.js'
import mutations from '@/store/modules/departments/mutations.js'
import getters from '@/store/modules/departments/getters.js'

export default {
  state: cloneDeep(state),
  actions,
  mutations,
  getters,
}
